module.exports = __webpack_public_path__ + "static/media/icon7.e8991625.svg";